<template>
    <div class="message">
        <el-button type="primary">message {{ msg }} 按钮11</el-button>
    </div>
</template>

<script>

export default {
    name: 'DapMessage',
    props: {
        msg: String
    },
};
</script>

<style scoped lang="scss">
.message {
    margin: 10px auto;
    padding: 5px 10px;
    color: #0f0;
    background: #000;
}
</style>
